import { getPushSessionToken } from "./helpers/helper.service";

export const base_url = process.env.REACT_APP_API_URL;

export function getAccessToken() {
  const okta_token_storage = localStorage.getItem("session");
  return JSON.parse(okta_token_storage ? okta_token_storage : "{}")?.accessToken
    ?.accessToken;
}

export function getUserInfoFromStorage() {
  const userInfo = localStorage.getItem("user-info");
  return JSON.parse(!!userInfo ? userInfo : "{}");
}


export const Urls = {
  userInfo: (username: string, action: string) =>
    `/api/v1/recovery/getUserInfo?username=${username}&action=${action}`,
  forgotPassword: `/api/v1/recovery/forgot_password`,
  validateChallenge: `/api/v1/recovery/validateChallenge`,
  resetPassword: `/api/v1/recovery/resetPassword`,
  changePassword: `/api/v1/recovery/changePassword`,
  unlockAccount: `/api/v1/recovery/unlockAccount`,
  pollForPushSuccess: (username: string) =>
    `/api/v1/recovery/pollForPushSuccess?username=${username}&sessionToken=${getPushSessionToken()}`,
  unlockAccount_stepTwo: `/api/v1/recovery/unlockAccount_stepTwo`,
  validateAnswer: `/api/v1/recovery/validate_answer`,
  check_reset_password: `/api/v1/recovery/rotateUserPassword`,
  branding: `/api/v1/recovery/branding`,
  tecproofGenerate: `/api/v1/recovery/tecproof/generate`,
  tecproofVerify: `/api/v1/recovery/tecproof/verify`,
};

//get user info response keys
export const userEmailKey = "email";
export const userLoginKey = "login";
export const userUsernameKey = "user_name";
export const userRecoveryQuestionKey = "recovery_question";
export const sessionTokenKey = "sessionToken";
export const mobilePhoneKey = "mobilePhone";
export const callPhoneKey = "callPhone";
//header
export const accountRecoveryHeaderLabel = "Account Recovery";

export const forgotPasswordLabel = "Forgot Password";
export const changePasswordLabel = "Change Password";
export const unlockAccountLabel = "Unlock Account";

//factors

export const googleFactorProvider = "Google";
export const smsFactorType = "sms";
export const smsFactorProvider = "OKTA";
export const emailFactorType = "email";
export const emailFactorProvider = "OKTA";
export const callFactorType = "call";
export const voiceFactorType = "voice";
export const callFactorProvider = "OKTA";
export const googleTOTPFactorType = "token:software:totp";
export const oktaTOTPFactorType = "token:software:totp";
export const oktaTOTPFactorProvider = "OKTA";
export const questionFactorType = "question";
export const questionFactorProvider = "OKTA";
export const MFAQuestionKey = "MFA Question";
export const oktaPushFactorType = "push";
export const oktaPushFactorProvider = "OKTA";
export const yubicoTOTPHardwareType = "token:hardware";
export const yubicoTOTPHardwareProvider = "YUBICO";
export const RSATokenFactorType = "token";
export const RSATokenFactorProvider = "RSA";
export const DUOTOTPFactorType = "token:software:totp";
export const DUOTOTPFactorProvider = "DUO";
export const DUOPushFactorType = "push";
export const DUOPushFactorProvider = "DUO";
export const DUOFactorType = "web";
export const DUOFactorProvider = "DUO";
export const DUOSMSFactorType = "sms";
export const HOTPFactorType = "token:hotp";
export const HOTPFactorProvider = "Custom";
export const CREDENTIFactorProvider = "CREDENTI";
export const FACE_AUTHFactoryType = "face_auth";
export const authentifaceFactorProvider = "AUTHENTIFACE";
export const authentifaceFactorType = "face_password";

//navigate routes
export const factorsAuthorizeRoute = "/FactorAuthorize";
export const recoveryQuestionRoute = "/RecoveryQuestion";
export const recoveryOptionRoute = "/RecoveryOption";
export const confirmationRoute = "/Confirmation";
export const recoveryHomePageRoute = "/";
export const noPortalAccess = "/NoPortalAccess";

///error messages
export const invalidUsernameMsg = "Enter Valid Username";
export const apigetUserDetailsErrorMsg =
  "An Error Has Occured While Getting User Info";
export const apiforgotPasswordErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiValidateChallengeErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiResetPasswordErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiChangePasswordErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiUnlockAccountErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiPollForSuccessErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiUnlockAccountStepTwoErrorMsg =
  "An Error Has Occured With Calling API Service";
export const apiValidateAnswerErrorMsg =
  "An Error Has Occured With Calling API Service";
export const genericErrorMsg = "Something went wrong. Please try again";
export const APITimeoutErrorMsg =
  "An error has been occurred. Please contact administrator";

//success messages
export const forgotPasswordSuccessMsg = "Password Reset Successful";
export const changePasswordSuccessMsg = "Password Changed";
export const pushSentSuccessMsg = "Push Sent Successfully";
export const passcodeVerifySuccesMsg = "Verified Successfully";
export const answerVerifySuccesMsg = "Answer Verified";
export const accountUnlockSuccessMsg = "Account Unlocked";
export const codeSentSuccessMsg = "Code Sent Successfully";
export const authentifaceSuccessMsg =
  "Face verification successful. Please proceed with account recovery now";
export const pushApprovedMsg = "Push Approved";
export const pushTimeoutMsg = "Push Timed Out";

export const passcodeEmptyMsg = "Passcode must be provided";
export const passwordEmptyMsg = "Password must be provided";
export const answerEmptyMsg = "Answer must be provided";


export default Urls;
